import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const NoCommentsIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="160"
        height="130"
        viewBox="0 0 160 130"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7734 40.249H103.285C108.919 40.249 113.491 44.8277 113.491 50.4805V101.996C113.491 107.649 108.919 112.228 103.285 112.228H33.6055L33.375 112.35L5.56738 127.056V50.4805C5.56749 44.8277 10.1395 40.249 15.7734 40.249Z"
          fill="white"
          stroke="#EDEFF6"
          strokeWidth="2.1"
        />
        <path
          d="M60.4667 80.2512C62.3542 79.9448 63.636 78.1663 63.3296 76.2788C63.0232 74.3913 61.2447 73.1096 59.3571 73.4159C57.4696 73.7223 56.1878 75.5008 56.4942 77.3883C56.8006 79.2759 58.5791 80.5576 60.4667 80.2512Z"
          fill="#EDEFF6"
        />
        <path
          d="M48.7847 80.206C50.6458 79.7667 51.7985 77.9019 51.3592 76.0408C50.92 74.1797 49.0551 73.0271 47.194 73.4664C45.3329 73.9056 44.1803 75.7704 44.6196 77.6315C45.0588 79.4926 46.9236 80.6452 48.7847 80.206Z"
          fill="#EDEFF6"
        />
        <path
          d="M72.1371 80.2493C74.0246 79.9429 75.3064 78.1644 75 76.2769C74.6936 74.3894 72.9151 73.1076 71.0275 73.414C69.14 73.7204 67.8582 75.4989 68.1646 77.3864C68.471 79.2739 70.2495 80.5557 72.1371 80.2493Z"
          fill="#EDEFF6"
        />
        <path
          d="M138.395 5.64062H77.1362C73.3394 5.64072 70.2573 8.72695 70.2573 12.5381V52.5986C70.2574 56.4097 73.3395 59.495 77.1362 59.4951H125.978L126.198 59.6113L145.274 69.7002V12.5381C145.274 8.84591 142.381 5.8339 138.749 5.64941L138.395 5.64062Z"
          fill="#EDEFF6"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M106.983 36.5559C105.357 36.2919 104.252 34.7595 104.516 33.1332C104.78 31.5069 106.313 30.4026 107.939 30.6665C109.565 30.9305 110.67 32.4629 110.406 34.0892C110.142 35.7155 108.609 36.8199 106.983 36.5559Z"
          fill="#676979"
        />
        <path
          d="M117.051 36.5162C115.447 36.1377 114.454 34.531 114.832 32.9274C115.211 31.3239 116.818 30.3308 118.421 30.7093C120.025 31.0877 121.018 32.6945 120.639 34.298C120.261 35.9015 118.654 36.8946 117.051 36.5162Z"
          fill="#676979"
        />
        <path
          d="M96.9284 36.554C95.3021 36.29 94.1977 34.7576 94.4617 33.1313C94.7257 31.505 96.2581 30.4006 97.8844 30.6646C99.5107 30.9286 100.615 32.461 100.351 34.0873C100.087 35.7136 98.5547 36.818 96.9284 36.554Z"
          fill="#676979"
        />
      </svg>
    </Center>
  );
};
